import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  z-index: 1;\n\n  @media print {\n    display: none;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  max-width: 800px;\n  overflow: hidden;\n  padding-top: 40px;\n  position: relative;\n  width: 100%;\n\n  @media print {\n    padding-top: 0;\n    width: 100%;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  flex-direction: column;\n  position: relative;\n\n  &::before {\n    background-color: ", ";\n    content: '';\n    height: 260px;\n    ", ";\n  }\n\n  @media print {\n    &::before {\n      display: none;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import { position } from 'polished';
import { color } from '@scp/ui-shared/theme/variables';
export var fullscreenLayoutBase = css(_templateObject(), color.header, position('absolute', '0', '0', null, '0'));
export var contentBase = css(_templateObject2());
export var closeButtonBase = css(_templateObject3(), position('absolute', '28px', null, null, '28px'));